import {
  FocusCompleteResponse,
  FocusProspectsResponse,
  FocusQueueItemType,
  FocusQueueResponse,
  FocusSessionHistoryItem,
  FocusSessionResponse,
  FocusSnoozeResponse,
} from '@business/entities/focusMode';
import { Endpoint } from '../endpoint';

export function fetchQueue(fresh = false) {
  return Endpoint.get<FocusQueueResponse>(`@gc/focus-mode/queue`, { params: { fresh: fresh ? 'true' : undefined } });
}

export function fetchProspects(limit?: number) {
  return Endpoint.get<FocusProspectsResponse>(`@gc/focus-mode/prospects`, { params: { limit } });
}

export function startSession() {
  return Endpoint.post<{ session: FocusSessionResponse }>(`@gc/focus-mode/session`);
}

export function fetchSession() {
  return Endpoint.get<{ session: FocusSessionResponse }>(`@gc/focus-mode/session`);
}

/**
 * Past sessions, newest first. userId is admin-only server-side.
 *
 * The key is omitted rather than passed as undefined: the request serialiser writes the
 * literal string "undefined" into the query, which the endpoint rejects as a non-integer.
 */
export function fetchSessions(limit?: number, userId?: string) {
  return Endpoint.get<{ sessions: FocusSessionHistoryItem[] }>(`@gc/focus-mode/sessions`, {
    params: userId ? { limit, userId } : { limit },
  });
}

export function heartbeat(actionsTaken = 0) {
  return Endpoint.post<{ session: FocusSessionResponse }>(`@gc/focus-mode/heartbeat`, { data: { actionsTaken } });
}

export function endSession() {
  return Endpoint.post<{ session: FocusSessionResponse | null }>(`@gc/focus-mode/end-session`);
}

export function snoozeItem(itemType: FocusQueueItemType, itemId: string, minutes: number) {
  return Endpoint.post<FocusSnoozeResponse>(`@gc/focus-mode/snooze`, { data: { itemType, itemId, minutes } });
}

export function unsnoozeItem(itemType: FocusQueueItemType, itemId: string) {
  return Endpoint.post<{ status: boolean }>(`@gc/focus-mode/unsnooze`, { data: { itemType, itemId } });
}

export function completeItem(itemType: FocusQueueItemType, itemId: string, actionsTaken = 0) {
  return Endpoint.post<FocusCompleteResponse>(`@gc/focus-mode/complete`, { data: { itemType, itemId, actionsTaken } });
}
